import React, { Suspense } from 'react';

import { CHAT_CARD_LAYOUT } from '../../aisdk';
import { AiPanelSlot } from '../Concierge/AiPanelSlot';
import { useAIChatState } from '../Concierge/useAIChatState';
import { useAiPanelHidden } from '../Concierge/useAiPanelHidden';
import { ShellContentGrid } from './ShellContentGrid';

const LazyConciergeAgent = React.lazy(() => import('../Concierge'));

interface AiShellSectionProps {
  mainContent: React.ReactNode;
  hideAiAgent: boolean;
}

export const AiShellSection = ({
  mainContent,
  hideAiAgent,
}: AiShellSectionProps) => {
  const { isOpen: isChatOpen } = useAIChatState();
  const aiShellTrackPx = isChatOpen ? CHAT_CARD_LAYOUT.shellColumnWidthPx : 0;
  const aiPanelHidden = useAiPanelHidden();

  if (hideAiAgent || aiPanelHidden) {
    return <>{mainContent}</>;
  }

  return (
    <>
      <ShellContentGrid sidePanelWidth={aiShellTrackPx}>
        {mainContent}
        <AiPanelSlot />
      </ShellContentGrid>
      <Suspense fallback={<React.Fragment />}>
        <LazyConciergeAgent />
      </Suspense>
    </>
  );
};
